export default function Legal() {
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="font-heading font-bold text-section text-neutral-800 mb-8">
          Aviso Legal
        </h1>

        <div className="prose prose-neutral max-w-none">
          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">1. Datos de Identificación</h2>
          <p>
            De conformidad con la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
            Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:
          </p>
          <ul>
            <li>Denominación Social: [Nombre de la ONG]</li>
            <li>NIF/CIF: [XXXXXXX-X]</li>
            <li>Domicilio: [Dirección completa]</li>
            <li>Teléfono: +34 XXX XXX XXX</li>
            <li>Email: contact@learnleadchange.org</li>
            <li>Inscripción en Registro de Asociaciones: [Número de registro]</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">2. Objeto y Ámbito</h2>
          <p>
            Esta plataforma tiene como objetivo proporcionar educación accesible sobre temas cívicos,
            políticos y sociales, y facilitar la participación ciudadana activa a través de campañas y
            movimientos sociales.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">3. Condiciones de Uso</h2>
          <p>
            El acceso y uso de esta plataforma implica la aceptación de estas condiciones legales. Los
            usuarios se comprometen a hacer un uso responsable de los contenidos y servicios ofrecidos.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">4. Propiedad Intelectual</h2>
          <p>
            Los contenidos educativos de esta plataforma están bajo licencia Creative Commons
            BY-NC-SA 4.0. Puedes compartir y adaptar el material siempre que otorgues el crédito
            apropiado y no lo uses con fines comerciales.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">5. Limitación de Responsabilidad</h2>
          <p>
            Esta plataforma se proporciona "tal como está". La organización no garantiza la exactitud
            o integridad de todos los contenidos educativos. La participación en campañas cívicas es
            responsabilidad del usuario.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">6. Legislación Aplicable</h2>
          <p>
            Estas condiciones se rigen por la legislación española. Para la resolución de cualquier
            conflicto, las partes se someterán a los Juzgados y Tribunales del domicilio del usuario.
          </p>
        </div>
      </div>
    </div>
  )
}
